import UserTypes from '../user/user.types';
import CallLogTypes from './callLog.types';
import CallLogState, {ICallLog} from './callLog.state';
import AnyAction from 'store/anyActions';
import ContactTypes from 'store/contact/contact.types';
import {mergeAttributesIntoContact} from '../contact/contact.utils'
import { isToday } from 'date-fns';
import AppTypes from 'store/app/app.types';
import {AppConfig} from 'store/app/app.state';
import MetricTypes from 'store/metrics/metrics.types';
import SettingsTypes from "../settings/settings.types";
import {ISettings} from "@missionlabs/smartagent-lib-shared/build/settings";
import { MS_IN_HOUR } from 'constants/index';

export default function ( state: CallLogState = [], action: AnyAction): CallLogState {
    switch (action.type) {
        case CallLogTypes.ADD_TO_CALL_LOG:
            if (state.map(contact => contact.ID).includes(action.payload.ID)) {
                // Check if this contact has already been added to the store
                return state;
            }
            if (!action.payload.ID) {
                return state;//Calls that didn't connect needn't go in the call log.
            }
            return [
                action.payload,
                ...state,
            ]
        case AppTypes.INIT_APP_SUCCESS:{
            const { callHistoryPeriodInHours } = action.payload.appConfig as AppConfig;
            //Dont keep local call state for longer than callHistoryPeriodInHours or 48hours - local storage *should* be overwritten by api call
            const expiry = new Date(Date.now() - ( callHistoryPeriodInHours ?? 48) * MS_IN_HOUR)
            return Array.isArray(state) ? state.filter(call=>{
                return new Date(call?.connectedToAgentTimestamp ?? call?.initiationTimestamp) > expiry;
            }) : [];
        }
        case SettingsTypes.GET_SETTINGS: {
            const { appConfigurations } = action.payload as ISettings;
            //Dont keep local call state for longer than callHistoryPeriodInHours or 48hours - local storage *should* be overwritten by api call
            if(typeof appConfigurations?.callHistoryHours === "number"){
                const expiry = new Date(Date.now() - ( appConfigurations?.callHistoryHours ) * MS_IN_HOUR)
                return Array.isArray(state) ? state.filter(call=>{
                    return new Date(call?.connectedToAgentTimestamp ?? call?.initiationTimestamp) > expiry;
                }) : [];
            }
            return state
        }
        case AppTypes.SELECT_INSTANCE:
            //Incase local storage is from a different login
            return state.filter(call=>call?.instanceID===action.payload.instance.ID)
        case ContactTypes.UPDATE_CONTACT_ATTRIBUTES:
            return state.map(c=>{
                if(c.ID !== action.payload.ID) return c;
                return mergeAttributesIntoContact(c,action.payload.attributes) as ICallLog;
            });
        //Can this action be used to override some of our local call log entries?
        case MetricTypes.GET_CONTACTS:
            return state.map(contact=>{
                if(contact.source !== 'LOCAL') return contact;
                const apiContact = action.payload.find(c=>c.ID===contact.ID);
                if(!apiContact) return contact;
                return {
                    ...apiContact,
                    type: "phone",
                    source:'API',
                }
            });
        case CallLogTypes.GET_CALL_LOG: {
            const localHistory = Array.isArray(state) ? state : [];
            const allHistory = [...action.payload, ...localHistory];
            return allHistory.filter((contact,i)=>{
                return allHistory.findIndex(c=>c.ID === contact.ID) === i;
            }).sort((c1, c2) => (c1.connectedToAgentTimestamp ?? c1.initiationTimestamp) < (c2.connectedToAgentTimestamp ?? c2.initiationTimestamp) ? 1 : -1)
        }

        case CallLogTypes.FLUSH_OLD_CALL_LOGS: {
            const localHistory = Array.isArray(state) ? state : [];
            return localHistory.filter(({ initiationTimestamp }: ICallLog) => {
                const initiationDate = new Date(initiationTimestamp);
                return isToday(initiationDate);
            });
        }

        case ContactTypes.GET_CONTACT:
            return state.map(contact=>{
                if(contact.ID === action.payload.ID){
                    return {
                        ...action.payload,
                        source:'API'
                    }
                }
                return contact;
            })
        case UserTypes.USER_AUTHENTICATED:
            //Fixes the case where local storage
            if(!Array.isArray(state)){
                return [];
            }
            return state.filter(callHistory=>callHistory.agentID===action.payload.agentID)
        default:
            return state;
    }
}


